import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {postRequest} from "../../../api";

export const handleCreateDefaultProgram = createAsyncThunk('showPlan/handleCreateDefaultProgram', async(allData) => {
    const {localPlanData, history} = allData
    try{
        const response = await postRequest("/coach/program/default", localPlanData)
        if(response.status === 200){
            setTimeout(() => {
                history.push("/plans/defaults");
            }, 1500);
        }
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

export const handleSendAcceptedProgram = createAsyncThunk('showPlan/handleSendAcceptedProgram', async(allData) => {
    const {localPlanData, history} = allData
    try{
        const response = await postRequest("/member/coach-program", localPlanData)
        if(response.status === 200){
            setTimeout(() => {
                history.push("/direct");
            }, 1500);
        }
    }
    catch(err){
        console.log(err.response.data.message)
    }
})

const showPlanSlice = createSlice({
    name: 'showPlan',
    initialState: {
        isLoading: false,
        savedProgram: false,
        snackBarMessage: {
            open: false,
            message: null,
            type: "submit",
        },
    },
    reducers: {
        setShowPlanSnackBarMessage: (state, action) => {
            state.snackBarMessage = action?.payload
        },
        setShowPlanLoading: (state, action) => {
            state.isLoading = action?.payload
        },
        setSavedProgram: (state, action) => {
            state.savedProgram = action?.payload
        },
    },
    extraReducers(builder){
        builder
            .addCase(handleCreateDefaultProgram.fulfilled, (state) => {
                state.isLoading = false
                state.savedProgram = true
                state.snackBarMessage = {
                    open: true,
                    message: "با موفقیت ذخیره شد",
                    type: "submit",
                }
            })
            .addCase(handleCreateDefaultProgram.pending, (state) => {
                state.isLoading = true
            })
            .addCase(handleCreateDefaultProgram.rejected, (state) => {
                state.isLoading = false
                state.snackBarMessage = {
                    open: true,
                    message: "خطایی رخ داد",
                    type: "error",
                }
            })
        builder
            .addCase(handleSendAcceptedProgram.fulfilled, (state) => {
                state.isLoading = false
                state.savedProgram = true
                state.snackBarMessage = {
                    open: true,
                    message: "با موفقیت ذخیره شد",
                    type: "submit",
                }
            })
            .addCase(handleSendAcceptedProgram.pending, (state) => {
                state.isLoading = true
            })
            .addCase(handleSendAcceptedProgram.rejected, (state) => {
                state.isLoading = false
                state.snackBarMessage = {
                    open: true,
                    message: "خطایی رخ داد",
                    type: "error",
                }
            })
    }
})

export const {setShowPlanSnackBarMessage, setShowPlanLoading, setSavedProgram} = showPlanSlice.actions
export const selectShowPlanLoading = state => state.showPlan.isLoading
export const selectSavedProgram = state => state.showPlan.savedProgram
export const selectShowSnackBarMessage = state => state.showPlan.snackBarMessage

export default showPlanSlice.reducer